import { createFileRoute, redirect } from '@tanstack/react-router'
import { useEffect } from 'react'
import { isIdPInitiated, handleIdPInitiated } from '@/api/unified-auth'
import { useOktaCallback } from '@/hooks/use-okta-only-auth'
import { ProtectedRoute } from '@/components/auth/protected-route'

export const Route = createFileRoute('/')({
  component: Index,
  beforeLoad: async () => {
    // Only handle IdP-initiated login in beforeLoad
    // Regular authentication will be handled by ProtectedRoute component
    if (isIdPInitiated()) {
      try {
        const result = await handleIdPInitiated()
        if (result) {
          // Successfully authenticated via IdP, continue to dashboard
          return
        }
        // Will redirect to Okta, no need to continue
        return
      } catch (error) {
        console.error('IdP-initiated login failed:', error)
        throw redirect({ to: '/login' })
      }
    }
    // Skip authentication check here - let ProtectedRoute handle it
  },
})

function Index() {
  const oktaCallback = useOktaCallback()

  useEffect(() => {
    // Handle any remaining IdP-initiated login processing
    const handleIdPLogin = async () => {
      if (isIdPInitiated()) {
        try {
          const result = await handleIdPInitiated()
          if (result) {
            // Update auth state
            oktaCallback.mutate(undefined, {
              onSuccess: () => {
                // Auth state updated successfully
              },
              onError: error => {
                console.error('Failed to update auth state:', error)
              },
            })
          }
        } catch (error) {
          console.error('IdP login processing failed:', error)
        }
      }
    }

    handleIdPLogin()
  }, [oktaCallback])

  return (
    <ProtectedRoute>
      <div className="p-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-[#006837] text-white rounded-full mb-4">
                <span className="text-2xl font-bold">h</span>
              </div>
              <h1 className="text-3xl font-bold text-gray-900 mb-2">Welcome to homebody</h1>
              <p className="text-lg text-gray-600">Admin Dashboard</p>
            </div>
          </div>
        </div>
      </div>
    </ProtectedRoute>
  )
}
